import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  ImageField,
  NumberField,
  ChipField,
  UrlField,
  SearchInput,
  SelectInput,
  TextInput,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  ImageInput,
  NumberInput,
  Create,
  Show,
  SimpleShowLayout,
} from 'react-admin'

import { CustomRichTextInput } from '../components/CustomRichTextInput'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const ProductList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <SelectInput
        source="currency"
        choices={[
          { id: 'UAH', name: 'UAH' },
          { id: 'USD', name: 'USD' },
        ]}
      />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <RichTextField source="description" />
      <TextField source="details" />
      <TextField source="category" />
      <TextField source="formats" />
      <ImageField source="imageUrl" title="imageUrl" />
      <NumberField source="priceInCents" />
      <ChipField source="currency" />
      <UrlField source="sourceUrl" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const ProductEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="title" />
      <CustomRichTextInput source="description" />
      <TextInput source="details" />
      <TextInput source="category" />
      <TextInput source="formats" />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="imageUrlInput" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <NumberInput source="priceInCents" />
      <SelectInput
        source="currency"
        choices={[
          { id: 'UAH', name: 'UAH' },
          { id: 'USD', name: 'USD' },
        ]}
      />
    </SimpleForm>
  </Edit>
)

export const ProductCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" />
      <CustomRichTextInput source="description" />
      <TextInput source="details" />
      <TextInput source="category" />
      <TextInput source="formats" />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="imageUrlInput" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <NumberInput source="priceInCents" />
      <SelectInput
        source="currency"
        choices={[
          { id: 'UAH', name: 'UAH' },
          { id: 'USD', name: 'USD' },
        ]}
      />
    </SimpleForm>
  </Create>
)

export const ProductShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <RichTextField source="description" />
      <TextField source="details" />
      <TextField source="category" />
      <TextField source="formats" />
      <ImageField source="imageUrl" title="imageUrl" />
      <NumberField source="priceInCents" />
      <ChipField source="currency" />
      <UrlField source="sourceUrl" />
    </SimpleShowLayout>
  </Show>
)
